export const gridColumns = [
  {
    title: 'Title',
    propKey: 'Title',
  },
];

export const emptyValue = { name: '', value: null };
